import React, { useState,FC,useEffect } from 'react';
import { Grid,Typography,Tooltip,IconButton,Theme} from '@mui/material';
import { makeStyles } from '@mui/styles';
import ArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import ArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSession } from 'hooks/SessionProvider';
import { useStore } from 'store/StoreProvider';
import moment from 'moment';
import useGetParsedDateTime from 'hooks/useGetParsedDateTime';
import MonthLabels from './components';

const useStyles = makeStyles((theme:Theme) => ({
  callenderMainBody:{
    display:"flex",
    justifyContent:"space-between",
    [theme.breakpoints.up('md')]:{
        width:"100% !important"
    },
     [theme.breakpoints.down('lg')]:{
        width:"100%",
        marginTop:"20px"
    },
    width:"100% !important"
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dateBox: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]:{
        width:"14%",
    },
    
    [theme.breakpoints.up('xl')]:{
        width:"14%",
    },
    [theme.breakpoints.down('md')]:{
        paddingLeft:"15px",
        paddingRight:"15px",
        width:"100%",
        display:"flex",
        alignItems:"center",
        gap:"10px !important"
    },
    
  },
  DayNames:{
    [theme.breakpoints.up('md')]:{
        fontSize:"14px !important",
    },
     [theme.breakpoints.down('md')]:{
        fontSize:"15px !important",
    },
    fontFamily: 'Open Sans !important',
    fontSize:"12px !important",
    color:"#3D5A80!important",
    fontWeight:"600 !important"
  },
  dateMonth: {
    fontFamily: 'Open Sans !important',
    fontSize: "13px !important",
    color: "#2b2b2b!important",
    fontWeight: "600 !important",
    [theme.breakpoints.down('md')]:{
      fontSize: "14px !important",
    }
  },
  callendar:{
    [theme.breakpoints.up('md')]:{
      width:"100%"
    }
  }
}));

interface props{

}

const CalendarStrip:FC<props> = ({}) => {
  const theme = useTheme();
  const classes = useStyles();
  const store=useStore();
  const data=store.getData();
  const {startedDate,setStartedDate}=useSession();
  const [isPrevDisabled, setIsPrevDisabled] = useState(true); // State to track if previous button should be disabled
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));
  const daysToShow = isSmallScreen? 1:data?.DaysToShow;
  const[calendarDate,setCalendarDate]=useState(startedDate);
  const currentDate = useGetParsedDateTime(data?.start_datetime)
  useEffect(() => {
    updatePrevButtonState(calendarDate);
    if(typeof calendarDate!=="undefined") setStartedDate(calendarDate);
  }, [calendarDate,currentDate]);


  useEffect(()=>{
    setCalendarDate(startedDate)
  },[startedDate])

  const updatePrevButtonState = (date: moment.Moment) => {
   typeof currentDate!=="undefined" && setIsPrevDisabled(date?.isSameOrBefore(currentDate,"day"));
  };

  const handlePrevClick = () => {
    const newStartDate = calendarDate?.clone().subtract(daysToShow, 'days');
    if (newStartDate?.isSameOrBefore(currentDate)) {
      newStartDate.set({
        year: currentDate?.year(),
        month: currentDate?.month(),
        date: currentDate?.date()
      });
    }
    updatePrevButtonState(newStartDate);
    setCalendarDate(newStartDate);
  };

  const handleNextClick = () => {
    const newStartDate = calendarDate?.clone().add(daysToShow, 'days');
    setCalendarDate(newStartDate);
  };

  const renderDates = () => {
    const dates = [];
    for (let i = 0; i < daysToShow; i++) {
      const currentDate = calendarDate?.clone().add(i, 'days');
      const dayName = currentDate?.format('ddd');
      const date = currentDate?.date();
      dates.push(
        <Grid item key={i} className={classes.dateBox}>
            <Grid
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                flexDirection: { xs: "row", md: "column" },
                alignItems: "center",
              }}
            >
              <Typography variant="body2" className={classes.DayNames}>
                {dayName}
              </Typography>
              <Typography
                variant="body2"
                className={classes.dateMonth}
                sx={{
                  ml: { xs: 1, md: 0 },
                  display: { xs: "inline", md: "block" },
                }}
              >
                {` ${date}`}
              </Typography>
            </Grid>
          </Grid>
      );
    }
    return dates;
  };

  return (
    <Grid className={classes.callenderMainBody}>
      <Grid sx={{padding:"10px",borderRadius:"50px"}} onClick={()=>{isSmallScreen && handlePrevClick()}}>
        <Tooltip title={""} onClick={handlePrevClick} sx={{backgroundColor:"#f6f6f6",
        color:"#3D5A80 !important",
          '&:hover': {
            backgroundColor: isPrevDisabled ? '#f6f6f6' : '#d6d6d6', // Prevent hover effect if disabled
          },
          cursor: isPrevDisabled ? 'not-allowed' : 'pointer'
        }}>
            <IconButton disabled={isPrevDisabled}>
                <ArrowLeft></ArrowLeft>
            </IconButton>
        </Tooltip>
      </Grid>
      <Grid className={classes.callendar}>
         <Grid> 
           <MonthLabels calendarDate={calendarDate} daysToShow={daysToShow}/>
         </Grid>
        <Grid container className={classes.dateContainer}>
          {renderDates()}
        </Grid>
      </Grid>
      <Grid sx={{padding:"10px",borderRadius:"50px"}}  onClick={()=>{isSmallScreen && handleNextClick()}}> 
        <Tooltip title={""} onClick={handleNextClick} sx={{backgroundColor:"#f6f6f6",
             
            '&:hover': {
              backgroundColor: '#d6d6d6', 
            },
        }}>
            <IconButton>
                <ArrowRight></ArrowRight>
            </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default CalendarStrip;
